import { render, staticRenderFns } from "./DataVolumeProgress.vue?vue&type=template&id=0ece7750"
import script from "./DataVolumeProgress.vue?vue&type=script&lang=js"
export * from "./DataVolumeProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports